import { useSettingsContext } from "@/components/Settings/hooks/useSettingsContext"
import { useFeatureEnabled } from "@/components/ErpFeatures/hooks/useErpFeatures";
import { ErpFeatureKeys } from "@/components/ErpFeatures/models/erpFeature";
import { useTranslation } from "react-i18next";

type ContractationInfo = {
  enabled?: boolean;
  untranslatedPath: string;
}

type ContractationTypes = {
  dual: ContractationInfo;
  electricity: ContractationInfo;
  gas: ContractationInfo;
};

type ActiveContractations = {
  num: number;
  types: ContractationTypes;
};

const useContractation = () => {
  const Settings = useSettingsContext();
  const { t } = useTranslation();  
  const personFirstPreleadEnabled = useFeatureEnabled(
    ErpFeatureKeys.CONTRACTATION_PERSON_FIRST_PRELEAD
  );
  const personFirstFlow = Settings.contractation?.flow === "person_first" &&
    personFirstPreleadEnabled;

  const activeContractations: ActiveContractations = {
    num: (
      Settings.contractation?.electricity?.enabled ? 1 : 0
    ) + (
      Settings.contractation?.gas?.enabled ? 1 : 0
    ) + (
      Settings.contractation?.dual?.enabled ? 1 : 0
    ),
    types: {
      dual: {
        enabled: Settings.contractation?.dual?.enabled,
        untranslatedPath: "common:url.dualContractation"
      },
      electricity: {
        enabled: Settings.contractation?.electricity?.enabled,
        untranslatedPath: "common:url.electricityContractation"
      },
      gas: {
        enabled: Settings.contractation?.gas?.enabled,
        untranslatedPath: "common:url.gasContractation"
      }
    }
  };

  const isContractationActive = activeContractations.num > 0;

  const isContractationPath = (path: string) => {
    return Object.values(activeContractations.types).some(
      contr => t(contr.untranslatedPath) === path
    );
  }

  const firstContractationPath: string | undefined =
  Object.entries(activeContractations.types).find(([key, contractationType]) =>
    contractationType.enabled
  )?.[1].untranslatedPath;

  return {
    activeContractations,
    isContractationActive,
    isContractationPath,
    firstContractationPath,
    personFirstFlow,
  }
}

export default useContractation;
